import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function OrganizationSwitcher({ className = "" }) {
  const { profile, memberships, setActiveOrganization } = useAuth();
  const [saving, setSaving] = useState(false);

  if (!profile?.organization_id || memberships.length < 2) return null;

  const onChange = async (event) => {
    const nextOrganizationId = event.target.value;
    if (!nextOrganizationId || nextOrganizationId === profile.organization_id) return;
    setSaving(true);
    try {
      await setActiveOrganization(nextOrganizationId);
      toast.success("Switched center");
    } catch (error) {
      toast.error(error.message || "Could not switch centers");
    } finally {
      setSaving(false);
    }
  };

  return (
    <label
      className={`relative flex min-w-0 items-center rounded-xl border border-neutral-200 bg-white px-2.5 py-1.5 text-xs text-neutral-600 ${className}`}
    >
      <span className="sr-only">Active center</span>
      <select
        data-testid="organization-switcher"
        value={profile.organization_id}
        disabled={saving}
        onChange={onChange}
        className="min-w-0 flex-1 appearance-none bg-transparent pr-5 font-medium text-neutral-700 outline-none disabled:cursor-wait"
      >
        {memberships.map((membership) => {
          const organization = membership.organization;
          const label = organization?.display_name || organization?.name || "Your center";
          return (
            <option key={membership.organization_id} value={membership.organization_id}>
              {label}
            </option>
          );
        })}
      </select>
      <CaretDown size={14} weight="bold" aria-hidden className="pointer-events-none absolute right-2.5 text-neutral-400" />
    </label>
  );
}
